import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

const getCommonGeneralSettings = createAsyncThunk('getCommonGeneralSettings', async () => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    let url = BILLING_ROUTES.GENERAL_SETTINGS.getCommon;
    const response = await fetch(`${url}?hospitalId=${hospitalId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch general settings');
    }
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
});

export default getCommonGeneralSettings;
